export const cardTypeToUserString = (type: CreditCardType) => {
	switch (type) {
		case "vis": return 'Visa'
		case "mcd": return 'MasterCard'
		case "diner": return 'Diners'
		case "amex": return 'American Express'
	}
	throw `unknown card type ${type}`
}

export const accountTypeToUserString = (type: AccountType) => {
	switch (type) {
		case "bank": return "Bank account"
		default: return cardTypeToUserString(type as CreditCardType /*fixme ts2: remove this cast*/)
	}
}

export type Currency = 'aud'|'nzd'|'pgk'

export const renderCurrencyName = (code: Currency) => {
	switch (code) {
		case 'aud': return 'Australian dollars';
		case 'nzd': return 'New Zealand dollars';
		case 'pgk': return 'kina';
	}

	throw `unknown currency code ${code}`
}



// WEBPACK FOOTER //
// ./src/lib/credit-card.ts